// @noflow
import styled, { injectGlobal } from 'styled-components';

import HiveDeviceIconsTtf from './device-icons.ttf';
import HiveDeviceIconsWoff from './device-icons.woff';
import HiveDeviceIconsWoff2 from './device-icons.woff2';
import HiveGeneralIconsTtf from './general-icons.ttf';
import HiveGeneralIconsWoff from './general-icons.woff';
import HiveGeneralIconsWoff2 from './general-icons.woff2';

// eslint-disable-next-line no-unused-expressions
injectGlobal`
	@font-face {
		font-family: HiveDeviceIcons;
		font-weight: normal;
		font-style: normal;
		src: url("${HiveDeviceIconsWoff2}") format("woff2"),
			url("${HiveDeviceIconsWoff}") format("woff"),
			url("${HiveDeviceIconsTtf}") format("truetype");
	}

	@font-face {
		font-family: HiveGeneralIcons;
		font-weight: normal;
		font-style: normal;
		src: url("${HiveGeneralIconsWoff2}") format("woff2"),
			url("${HiveGeneralIconsWoff}") format("woff"),
			url("${HiveGeneralIconsTtf}") format("truetype");
	}

`;

export const StyledIcon = styled.span`
    display: inline-block;
    vertical-align: middle;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-family: ${p => {
        const truthMap = { [true]: 'HiveGeneralIcons', [p.set === 'device']: 'HiveDeviceIcons' };
        return truthMap[true];
    }};
`;



// WEBPACK FOOTER //
// ./src/core/icons/style.js